import { combineReducers } from "@reduxjs/toolkit";
import { reducer as projectsReducer } from "../slices/projects";
import { reducer as flowReducer } from "../slices/flow";
import { reducer as projectReducer } from "../slices/project";
import { reducer as recordingReducer } from "../slices/recording";
import { reducer as workflowReducer } from "../slices/workflow";
import { reducer as globalReducer } from "../slices/global";

const rootReducer = combineReducers({
  projects: projectsReducer,
  flow: flowReducer,
  project: projectReducer,
  recording: recordingReducer,
  workflow: workflowReducer,
  global: globalReducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
